
import { AlertsPrimaryDarkIcon, AlertsPrimaryIcon, ChangepasswordPrimaryDarkIcon, ChangepasswordPrimaryIcon, ContactsPrimaryDarkIcon, ContactsPrimaryIcon, ConversationsPrimaryDarkIcon, ConversationsPrimaryIcon, DashboardPrimaryDarkIcon, DashboardPrimaryIcon, FalkonDocIcon, FalkonDocPrimaryIcon, FeaturesPrimaryDarkIcon, FeaturesPrimaryIcon, GroupsPrimaryDarkIcon, GroupsPrimaryIcon, OrganizationsPrimaryDarkIcon, OrganizationsPrimaryIcon, ReportsPrimaryDarkIcon, ReportsPrimaryIcon, ScheduleMessagePrimaryDarkIcon, ScheduleMessagePrimaryIcon, SecureChatActiveIcon, SecureChatGreyIcon, SettingsPrimaryDarkIcon, SettingsPrimaryIcon, TemplatesPrimaryDarkIcon, TemplatesPrimaryIcon, TiersPrimaryDarkIcon, TiersPrimaryIcon, TransferPrimaryDarkIcon, TransferPrimaryIcon, UsersPrimaryDarkIcon, UsersPrimaryIcon } from "../../icon";
import { PlanMetrics, UserPlanTracker } from "../../models/plan-metrics.model";
import { RouteModel } from "../../models/routes.model";
import { lazy } from 'react';
import { withErrorBoundaries } from "../shared/error-handler.component";
import { TeamsRoutes } from "./route.path";
import { LocalStorage } from "../../services/UtilityService";
import store from "../../stores/app-store";
import AccountBilling from "../account-billing/Account-billing";
import SecureDocs from '../falkon-docs/index';
import DisplaySuccessMaessageComponent from '../falkon-docs/display-success-message.component';
import FalkonSecureDocOtp from '../falkon-docs/secure-doc-otp-verification.component';
import EndUserSigningComponent from '../falkon-docs/end-user-signing.component';
import DisplaySignerSuccessMaessageComponent from '../falkon-docs/display-signer-success-message.component';
import FalkonSignedSecureDocOtp from '../falkon-docs/signed-secure-doc-otp-verification.component';
import CompletedPDFViewerComponent from '../falkon-docs/completed-secure-doc-view.component';
import SecureDocsUploads from '../falkon-docs/falkon-docs-uploads';

// const AlertsComponent = lazy(() => import('../alerts/alerts.component'));
// const Contacts = lazy(() => import("../contacts/contact.component"));
// const ConversationComponent = lazy(() => import('../conversations/conversation-component'));
// const Dashboard = lazy(() => import("../dashboard/dashboard-view.component"));
// const Features = lazy(() => import("../features/feature.component"));
// const Groups = lazy(() => import("../groups"));
// const GroupDeletionInfo = lazy(() => import('../groups/group-deletion-info.component'));
// const ForgotPassword = lazy(() => import("../login/forgot-password.component"));
// const Login = lazy(() => import("../login/login.component"));
// const ResetPassword = lazy(() => import("../login/reset-password.component"));
// const TwofactorAuthentication = lazy(() => import("../login/twofactor-authentication.component"));
// const Organizations = lazy(() => import("../organizations/organization.component"));
// const Changepassword = lazy(() => import("../profile/change-password.component"));
// const Profile = lazy(() => import("../profile/profile.component"));
// const BlockedContact = lazy(() => import("../reports/blocked-contacts.component"));
// const CreditLogsComponent = lazy(() => import("../reports/credit-logs-component"));
// const Reports = lazy(() => import('../reports/index'));
// const OptOutPolicy = lazy(() => import("../reports/optout-policy.component"));
// const ScheduledMessage = lazy(() => import('../scheduled-messages/scheduled-messages.component'));
// const FaceRegister = lazy(() => import("../secure-file/face-register.component"));
// const FaceVerification = lazy(() => import("../secure-file/face-verification.component"));
// const Settings = lazy(() => import("../settings/settings.component"));
// const SsoInactive = lazy(() => import('../shared/sso-inactive.component'));
// const Signup = lazy(() => import("../signup"));
// const TemplateComponent = lazy(() => import("../templates"));
// const Tiers = lazy(() => import("../tiers/tier.component"));
// const Transfers = lazy(() => import("../transfers"));
// const Users = lazy(() => import("../users/user.component"));

import AlertsComponent from '../alerts/alerts.component';
import Contacts from "../contacts/contact.component";
import ConversationComponent from '../conversations/conversation-component';
import Dashboard from "../dashboard/dashboard-view.component";
import Features from "../features/feature.component";
import Groups from "../groups";
import GroupDeletionInfo from '../groups/group-deletion-info.component';
import ForgotPassword from "../login/forgot-password.component";
import Login from "../login/login.component";
import ResetPassword from "../login/reset-password.component";
import TwofactorAuthentication from "../login/twofactor-authentication.component";
import NewOrganization from "../new-Organizations/NewOrganization";
import OrgPlanHistoryComponent from "../new-Organizations/planHistory";
import NewUsers from "../new-Users/NewUsers";
import Organizations from "../organizations/organization.component";
import Changepassword from "../profile/change-password.component";
import Profile from "../profile/profile.component";
import BlockedContact from "../reports/blocked-contacts.component";
import CreditLogsComponent from "../reports/credit-logs-component";
import Reports from '../reports/index';
import OptOutPolicy from "../reports/optout-policy.component";
import ScheduledMessage from '../scheduled-messages/scheduled-messages.component';
import FaceRegister from "../secure-file/face-register.component";
import FaceVerification from "../secure-file/face-verification.component";
import Settings from "../settings/settings.component";
import SsoInactive from '../shared/sso-inactive.component';
import Signup from "../signup";
import TemplateComponent from "../templates";
import Tiers from "../tiers/tier.component";
import Transfers from "../transfers";
import Users from "../users/user.component";
import { LoginType } from "../../models/settings-model";

let existing_routes: RouteModel[] = [];
let user_id: string = "";

export const TeamsMobileRoutes = () => {
    const currentUser = LocalStorage.get("current-user")
    const isNewSubFlow = currentUser?.isNewSubFlow ?? false
    const userId = currentUser?.id ?? ""
    if (existing_routes?.length === 0 || user_id !== userId) {
        const routes: RouteModel[] = [
            {
                id: 111,
                path: TeamsRoutes.PROFILE,
                label: "Profile",
                component: withErrorBoundaries(Profile, "Profile"),
                isSideMenu: false,
                authenticationRequired: true,
                roles: [1, 2, 3, 4]
            },
            {
                id: 112,
                label: "Transfer Credits",
                path: TeamsRoutes.TRANSFERS,
                component: withErrorBoundaries(Transfers, "Transfer Credits"),
                primaryIcon: TransferPrimaryIcon,
                primaryDarkIcon: TransferPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                isUserMenu: true
            },
            {
                id: 113,
                path: TeamsRoutes.SETTINGS,
                label: "Settings",
                component: withErrorBoundaries(Settings, "Settings"),
                primaryIcon: SettingsPrimaryIcon,
                primaryDarkIcon: SettingsPrimaryDarkIcon,
                isSideMenu: false,
                isUserMenu: true,
                authenticationRequired: true,
                roles: [1, 2, 3, 4]
            },
            {
                id: 114,
                path: TeamsRoutes.CHANGE_PASSWORD,
                label: "Change password",
                primaryIcon: ChangepasswordPrimaryIcon,
                primaryDarkIcon: ChangepasswordPrimaryDarkIcon,
                component: withErrorBoundaries(Changepassword, "Change password"),
                isSideMenu: false,
                isUserMenu: true,
                authenticationRequired: true,
                roles: [1, 2, 3, 4]
            },


            {
                id: 115,
                path: TeamsRoutes.DASHBOARD,
                label: "Dashboard",
                component: withErrorBoundaries(Dashboard, "Dashboard"),
                primaryIcon: DashboardPrimaryIcon,
                primaryDarkIcon: DashboardPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [2, 3, 4]
            },
            // {
            //     id: 116,
            //     path: TeamsRoutes.PLANS,
            //     label: "Plans",
            //     component: withErrorBoundaries(Plans, "Plans"),
            //     IsBottomIcon: false,
            //     primaryIcon: PlansPrimaryIcon,
            //     primaryDarkIcon: PlansPrimaryDarkIcon,
            //     isSideMenu: true,
            //     authenticationRequired: true,
            //     roles: [2],
            //     exact: true
            // },
            {
                id: 117,
                path: TeamsRoutes.ORGANIZATIONS,
                label: "Organizations",
                component: withErrorBoundaries(Organizations, "Organizations"),
                primaryIcon: OrganizationsPrimaryIcon,
                primaryDarkIcon: OrganizationsPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [1]
            },
            // {
            //     id: 118,
            //     path: TeamsRoutes.PHONE_NUMBERS,
            //     label: "Phone Numbers",
            //     component: withErrorBoundaries(PhoneNumber, "Phone Numbers"),
            //     primaryIcon: PhoneNumbersPrimaryIcon,
            //     primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
            //     isSideMenu: true,
            //     authenticationRequired: true,
            //     roles: [1]
            // },
            {
                id: 119,
                label: "Users",
                path: isNewSubFlow ? TeamsRoutes.NEW_USERS : TeamsRoutes.USERS,
                component: withErrorBoundaries(isNewSubFlow ? NewUsers : Users, "Users"),
                primaryIcon: UsersPrimaryIcon,
                primaryDarkIcon: UsersPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [1, 2, 4]
            },
            {
                id: 120,
                path: TeamsRoutes.CONVERSATIONS,
                label: "Conversations",
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                primaryIcon: ConversationsPrimaryIcon,
                primaryDarkIcon: ConversationsPrimaryDarkIcon,
                isSideMenu: true,
                enableHighlight: true,
                highlightDataKey: "unreadMessageCount",
                authenticationRequired: true,
                roles: [2, 3, 4]
            },
            {
                id: 102,
                label: "Secure Chat",
                path: `${TeamsRoutes.SECURE_CONVERSATIONS}/*`,
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                primaryIcon: SecureChatGreyIcon,
                primaryDarkIcon: SecureChatActiveIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true,
                highlightDataKey: "secureChatUnReadMessageCount",
                enableHighlight: true,
                hasSubRoutes: false,
                exact: true,
                PlanFilter: "HasAccessToSecureChat",
            },
            {
                id: 121,
                path: TeamsRoutes.SCHEDULED_MESSAGES,
                label: "Scheduled",
                component: withErrorBoundaries(ScheduledMessage, "Scheduled Messages"),
                primaryIcon: ScheduleMessagePrimaryIcon,
                primaryDarkIcon: ScheduleMessagePrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [2, 3, 4],
                PlanFilter: "HasMessageScheduling",
            },
            {
                id: 122,
                path: TeamsRoutes.CONTACTS,
                label: "Contacts",
                component: withErrorBoundaries(Contacts, "Contacts"),
                primaryIcon: ContactsPrimaryIcon,
                primaryDarkIcon: ContactsPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [2, 3, 4],
                exact: true,
            }, {
                id: 123,
                path: TeamsRoutes.GROUPS,
                label: "Groups (Campaigns)",
                component: withErrorBoundaries(Groups, "Groups"),
                primaryIcon: GroupsPrimaryIcon,
                primaryDarkIcon: GroupsPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [2, 3, 4],
                exact: true,
                PlanFilter: isNewSubFlow ? "HasGroupBroadcast" : ""
            },

            {
                id: 124,
                path: TeamsRoutes.TIERS,
                label: "Plans",
                component: withErrorBoundaries(Tiers, "Plans"),
                primaryIcon: TiersPrimaryIcon,
                primaryDarkIcon: TiersPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [1]
            },
            {
                id: 125,
                path: TeamsRoutes.FEATURES,
                label: "Features",
                component: withErrorBoundaries(Features, "Features"),
                primaryIcon: FeaturesPrimaryIcon,
                primaryDarkIcon: FeaturesPrimaryDarkIcon,
                isSideMenu: true,
                authenticationRequired: true,
                roles: [1]
            },
            // {
            //     id: 126,
            //     label: "",
            //     path: TeamsRoutes.ADD_PHONE_NUMBER,
            //     component: withErrorBoundaries(AddPhoneNumber, "Add Number"),
            //     roles: [1, 2],
            //     authenticationRequired: true,
            //     isSideMenu: false
            // },
            // {
            //     id: 127,
            //     label: "",
            //     path: TeamsRoutes.PAYMENT_STATUS,
            //     component: withErrorBoundaries(PaymentStatusComponent, "Payment Status"),
            //     roles: [1, 2],
            //     authenticationRequired: true,
            //     isSideMenu: false
            // },
            // {
            //     id: 128,
            //     label: "",
            //     path: TeamsRoutes.RECHARGE,
            //     component: withErrorBoundaries(Recharge, "Recharge"),
            //     roles: [1, 2],
            //     authenticationRequired: true,
            //     isSideMenu: false
            // },
            // {
            //     id: 129,
            //     label: "",
            //     path: TeamsRoutes.REHOST,
            //     component: withErrorBoundaries(RehostComponent, "Rehost"),
            //     roles: [1, 2],
            //     authenticationRequired: true,
            //     isSideMenu: false
            // },
            {
                id: 130,
                label: "Alerts",
                path: TeamsRoutes.ALERTS,
                component: withErrorBoundaries(AlertsComponent, "Alerts"),
                primaryIcon: AlertsPrimaryIcon,
                primaryDarkIcon: AlertsPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            // {
            //     id: 131,
            //     label: "Automation",
            //     path: TeamsRoutes.AUTOMATION_RULES,
            //     component: withErrorBoundaries(AutoAlertRules, "Automation Rules"),
            //     roles: [2, 3],
            //     primaryIcon: AutomationPrimaryIcon,
            //     primaryDarkIcon: AutomationPrimaryDarkIcon,
            //     authenticationRequired: true,
            //     isSideMenu: true,
            //     HasSubRoutes: true,
            //     PlanFilter: "HasAccessAutoReplies",
            //     children: [{
            //         id: 1,
            //         label: "Automation Rules",
            //         SubRoutelabel: "Rules",
            //         path: TeamsRoutes.AUTOMATION_RULES,
            //         component: withErrorBoundaries(AutoAlertRules, "Automation Rules - Rules"),
            //         roles: [2, 3],
            //         authenticationRequired: true,
            //         isSideMenu: true
            //     },
            //     {
            //         id: 2,
            //         label: "Automation Rules - Keyword",
            //         SubRoutelabel: "Keyword",
            //         path: TeamsRoutes.AUTOMATION_KEYWORD,
            //         component: withErrorBoundaries(AutoAlertKeyword, "Automation Rules - Keyword"),
            //         roles: [2, 3],
            //         authenticationRequired: true,
            //         isSideMenu: true

            //     },
            //     {
            //         id: 30,
            //         label: "Automation Rules - Logs",
            //         SubRoutelabel: "Logs",
            //         path: TeamsRoutes.AUTOMATION_LOGS,
            //         component: withErrorBoundaries(AutoAlertLogs, "Automation Rules - Logs"),
            //         roles: [2, 3],
            //         authenticationRequired: true,
            //         isSideMenu: true
            //     }
            //     ]
            // },
            // {
            //     id: 131,
            //     label: "Falkon Sign",
            //     path: TeamsRoutes.FALKON_DOCS,
            //     component: withErrorBoundaries(SecureDocs, "Falkon Sign"),
            //     primaryIcon: FalkonDocPrimaryIcon,
            //     primaryDarkIcon: FalkonDocIcon,
            //     roles: [2, 3],
            //     authenticationRequired: true,
            //     isSideMenu: true,
            //     exact: true,
            //     PlanFilter: "HasAccessToSecureDoc",
            // },
            {
                id: 132,
                label: "Templates",
                path: TeamsRoutes.TEMPLATES,
                component: withErrorBoundaries(TemplateComponent, "Templates"),
                primaryIcon: TemplatesPrimaryIcon,
                primaryDarkIcon: TemplatesPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true
            },
            // {
            //     id: 133,
            //     label: "Import Contacts",
            //     path: TeamsRoutes.IMPORT_CONTACTS,
            //     component: withErrorBoundaries(ImportContacts, "import-contacts"),
            //     primaryIcon: ContactsPrimaryIcon,
            //     primaryDarkIcon: ContactsPrimaryDarkIcon,
            //     roles: [2, 3],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     exact: true
            // },
            // {
            //     id: 134,
            //     label: "Plan History",
            //     path: TeamsRoutes.PHONE_NUMBERS_PLAN_HISTORY,
            //     component: withErrorBoundaries(PlansHistoryComponent, "plan-history"),
            //     // Icon: ContactsSecondaryIcon,
            //     roles: [1],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     exact: true
            // },
            // {
            //     id: 135,
            //     label: "Plan History",
            //     path: TeamsRoutes.PLANS_PLAN_HISTORY,
            //     component: withErrorBoundaries(PlansHistoryComponent, "plan-history"),
            //     // Icon: ContactsSecondaryIcon,
            //     roles: [2],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     exact: true
            // },
            // {
            //     id: 136,
            //     label: "Switch Phone Number",
            //     path: TeamsRoutes.SWITCH_PHONE_NUMBER,
            //     component: withErrorBoundaries(SwitchPhoneNumber, "SwitchPhoneNumber"),
            //     primaryIcon: SwitchPhoneNumberPrimaryIcon,
            //     primaryDarkIcon: SwitchPhoneNumberPrimaryDarkIcon,
            //     roles: [2],
            //     authenticationRequired: true,
            //     isSideMenu: true,
            // },
            // {
            //     id: 137,
            //     label: "Kafka Cluster",
            //     path: TeamsRoutes.KAFKA_CLUSTER,
            //     component: withErrorBoundaries(KafkaComponent, "Kafka Cluster"),
            //     primaryIcon: KafkaPrimaryIcon,
            //     primaryDarkIcon: KafkaPrimaryDarkIcon,
            //     roles: [1],
            //     authenticationRequired: true,
            //     isSideMenu: true,
            // },
            {
                id: 138,
                label: "",
                path: TeamsRoutes.GROUPDELETIONINFO,
                component: withErrorBoundaries(GroupDeletionInfo, "GroupDeletionInfo"),
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },

            {
                id: 139,
                label: "Conversations",
                path: TeamsRoutes.CONVERSATION_HISTORY,
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },

            {
                id: 140,
                label: "Conversations",
                path: TeamsRoutes.CONVERSATION_HISTORY,
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },
            {
                id: 141,
                label: "Reports",
                path: TeamsRoutes.REPORTS,
                component: withErrorBoundaries(Reports, "Reports"),
                primaryIcon: ReportsPrimaryIcon,
                primaryDarkIcon: ReportsPrimaryDarkIcon,
                roles: [3, 4],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 142,
                label: "Reports",
                path: TeamsRoutes.REPORTS,
                component: withErrorBoundaries(Reports, "Reports"),
                roles: [2, 4],
                primaryIcon: ReportsPrimaryIcon,
                primaryDarkIcon: ReportsPrimaryDarkIcon,
                authenticationRequired: true,
                isSideMenu: true,
                hasSubRoutes: true,
                children: [{
                    id: 1,
                    label: "Broadcast & Schedule Logs",
                    subRouteLabel: "Schedule-broadcast-logs",
                    path: TeamsRoutes.REPORTS,
                    component: withErrorBoundaries(Reports, "Reports"),
                    roles: [1, 2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true
                },
                // {
                // 	id: 2,
                // 	label: "Message Logs",
                // 	SubRoutelabel: "message-logs",
                // 	path: TeamsRoutes.MESSAGE_LOGS,
                // 	component: withErrorBoundaries(MessageLogs, "Message-Logs"),
                // 	roles: [ 2, 3],
                // 	authenticationRequired: true,
                // 	isSideMenu: true
                // },
                {
                    id: 3,
                    label: "Credit Logs",
                    subRouteLabel: "Credit Logs",
                    path: TeamsRoutes.CreditLog,
                    component: withErrorBoundaries(CreditLogsComponent, "Reports - Credit Logs"),
                    roles: [1, 2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true,
                    hide: isNewSubFlow
                },
                {
                    id: 4,
                    label: "Opt-Out List",
                    subRouteLabel: "Opt-Out List",
                    path: TeamsRoutes.OPTOUT_POLICY,
                    component: withErrorBoundaries(OptOutPolicy, "Opt-Out List"),
                    roles: [2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true
                },
                {
                    id: 5,
                    label: "Blocked List",
                    subRouteLabel: "Blocked List",
                    path: TeamsRoutes.BLOCKED_CONTACTS_LIST,
                    component: withErrorBoundaries(BlockedContact, "Blocked List"),
                    roles: [2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true,
                    hide: isNewSubFlow ? "HasBlockList" : false
                },
                ].filter(x => isNewSubFlow ? !x.hide === isNewSubFlow : x)
            },
            // {
            //     id: 143,
            //     label: "",
            //     path: TeamsRoutes.SCHEDULED_REPORT,
            //     component: withErrorBoundaries(scheduledReportComponent, "scheduled report"),
            //     roles: [2],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     exact: true
            // },
            {
                id: 166,
                label: "Falkon Sign",
                path: TeamsRoutes.FALKON_DOCS_UPLOADS,
                component: withErrorBoundaries(SecureDocsUploads, "Falkon Sign Uploads"),
                primaryIcon: FalkonDocPrimaryIcon,
                primaryDarkIcon: FalkonDocIcon,
                roles: [2, 3],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },
            {
                id: 167,
                label: "",
                path: TeamsRoutes.FALKON_DOCS_SUCCESS,
                component: withErrorBoundaries(DisplaySuccessMaessageComponent, "Falkon Sign Configure Success"),
                roles: [2, 3],
                authenticationRequired: true,
                isSideMenu: false,
            },
            {
                id: 168,
                label: "",
                path: TeamsRoutes.FALKON_DOCS_OTP,
                component: withErrorBoundaries(FalkonSecureDocOtp, "Falkon Sign Otp"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 169,
                label: "",
                path: TeamsRoutes.FALKON_DOCS_END_USER_SIGN,
                component: withErrorBoundaries(EndUserSigningComponent, "Falkon Sign End User Sign"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 170,
                label: "",
                path: TeamsRoutes.FALKON_DOCS_END_USER_SIGN_SUCCESS,
                component: withErrorBoundaries(DisplaySignerSuccessMaessageComponent, "Falkon Sign End User Sign Success"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 171,
                label: "",
                path: TeamsRoutes.FALKON_DOCS_VERIFY_OTP,
                component: withErrorBoundaries(FalkonSignedSecureDocOtp, "Falkon Sign End User Verify OTP"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 172,
                label: "",
                path: TeamsRoutes.FALKON_DOCS_COMPLETED,
                component: withErrorBoundaries(CompletedPDFViewerComponent, "Completed Falkon Sign"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1111,
                label: "Login",
                path: TeamsRoutes.SIGN_IN,
                component: withErrorBoundaries(Login, "Login"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            },
            {
                id: 1112,
                label: "SignUp",
                path: TeamsRoutes.SIGN_UP,
                component: withErrorBoundaries(Signup, "Signup"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            },
            {
                id: 1113,
                label: "SignUp",
                path: TeamsRoutes.TWO_FACTOR_AUTHENTICATION,
                component: withErrorBoundaries(TwofactorAuthentication, "2FA"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            },
            {
                id: 1114,
                label: "Forgot Password",
                path: TeamsRoutes.TWO_FACTOR_AUTHENTICATION,
                component: withErrorBoundaries(ForgotPassword, "forgotPassword"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            },
            {
                id: 1115,
                label: "Reset Password",
                path: TeamsRoutes.RESET_PASSWORD_NEW,
                component: withErrorBoundaries(ResetPassword, "forgotPassword"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            },
            {
                id: 1116,
                label: "SSO error",
                path: TeamsRoutes.SSO_ERROR_PAGE,
                component: withErrorBoundaries(SsoInactive, "ssoError"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            },
            {
                id: 1117,
                label: "Face Registration",
                path: TeamsRoutes.FACE_REGISTRATION,
                component: withErrorBoundaries(FaceRegister, "faceRegistartion"),
                roles: [2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1118,
                label: "Face Verification",
                path: TeamsRoutes.FACE_VERIFICATION,
                component: withErrorBoundaries(FaceVerification, "faceVerification"),
                roles: [2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1119,
                label: "New Organizations",
                path: TeamsRoutes.NEW_ORGANIZATION,
                component: withErrorBoundaries(NewOrganization, "New Organizations"),
                primaryIcon: OrganizationsPrimaryIcon,
                primaryDarkIcon: OrganizationsPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 1120,
                label: "New Users",
                path: TeamsRoutes.NEW_USERS,
                component: withErrorBoundaries(NewUsers, "New Users"),
                primaryIcon: UsersPrimaryIcon,
                primaryDarkIcon: UsersPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 1121,
                label: "Seat History",
                path: TeamsRoutes.ORGANIZATION_PLAN_HISTORY,
                component: withErrorBoundaries(OrgPlanHistoryComponent, "Seat-history"),
                primaryIcon: ContactsPrimaryIcon,
                primaryDarkIcon: ContactsPrimaryDarkIcon,
                // secondaryIcon: ContactsPrimaryIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },
            {
                id: 1122,
                label: "Account & Billing",
                path: `${TeamsRoutes.ACCOUNT_BILLING}`,
                component: withErrorBoundaries(AccountBilling, "Account Billing"),
                primaryIcon: TemplatesPrimaryIcon,
                primaryDarkIcon: TemplatesPrimaryDarkIcon,
                roles: [2, 3],
                authenticationRequired: true,
                isSideMenu: true,
                hide: true
            },
        ].filter(x => !x.hide);

        existing_routes = routes;
        user_id = userId;
    }
    return existing_routes
}

export const getSideMenusTeams = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
    return TeamsMobileRoutes().filter(route => route.isSideMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

// export const getSideMenusBottom = (planMetrics: PlanMetrics): RouteModel[] => {
//     return teamsRoutes.filter(route => route.isSideMenu && route.IsBottomIcon && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]))
// }

export const getUserMenus = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
    let routes = TeamsMobileRoutes();
    const OrganizationLoginType = store.getState().OrganizationLoginType;
    if (OrganizationLoginType.SSOType !== LoginType.None) {
        routes = TeamsMobileRoutes().filter(x => x.label !== "Change Password")
    }
    return routes.filter(route => route.isUserMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}
export const getAuthorisedRoutes = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
    return TeamsMobileRoutes().filter(route => route.authenticationRequired && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUnAuthorisedRoutes = (): RouteModel[] => {
    return TeamsMobileRoutes().filter(route => !route.authenticationRequired)
}
